export const config = {
    // AI/RAG Python API
    pythonApiUrl: process.env.REACT_APP_PYTHON_API_URL || 'http://localhost:8885/api',

    // .NET Server API  
    apiServerUrl: process.env.REACT_APP_SERVER_API_URL || 'http://localhost:5062/api',
};

export const backgroundActionsUrl = process.env.REACT_APP_BACKGROUND_URL || 'https://mbk-assistant.codeindustry.net';